import React from 'react';
import { useLingui } from '@lingui/react';

import { Box, Text } from '@rover/kibble/core';
import { isReactNative } from '@rover/rsdk/src/modules/Network/userAgent';
import { PetType } from '@rover/types/src/Pet';

import { PriceTransparencyStringCollection } from '../SearchSectionHeader/builders/constants';

export type Props = {
  petType?: PetType;
};

const PtCondensedPetTypeDescription = ({ petType }: Props): JSX.Element => {
  const { i18n } = useLingui();
  const content = (
    <Text
      size="100"
      textColor="secondary"
      mb="2x"
      sx={{
        fontWeight: 400,
      }}
    >
      {PriceTransparencyStringCollection.ptCondensedSitterProfilePetType({
        i18n,
        petType,
      })}
    </Text>
  );

  // Wrapping Text component in a Box with accessibility props to make the text accessible on Android
  if (isReactNative()) {
    return (
      <Box
        rxnProps={{
          accessible: true,
          accessibilityRole: 'text',
        }}
      >
        {content}
      </Box>
    );
  }

  return content;
};

export default PtCondensedPetTypeDescription;
